import useAgentData from "@casino/legacy/client/hooks/useAgentData";
import GameDetailsTooltip from "@casino/legacy/client/shared/game/GameDetailsTooltip";
import type { GameFragment } from "@workspace/casino_core/fragments/GameFragment";
import type { SingleGameFragment } from "@workspace/casino_core/fragments/SingleGameFragment";
import InfoButton from "../InfoButton";
import DesktopInfoTooltip from "./DesktopInfoTooltip";

// List cards carry only the shared fields; the play page the full game.
type GameDetailsGame = GameFragment & Partial<SingleGameFragment>;

type Props = {
  game: GameDetailsGame;
};

const InfoTooltip: FC<Props> = ({ game }) => {
  const { isDesktop } = useAgentData();

  if (!game.rtp || !isDesktop) {
    return null;
  }

  return (
    <DesktopInfoTooltip
      trigger={<InfoButton />}
      content={<GameDetailsTooltip game={game} />}
    />
  );
};

export default InfoTooltip;
